import styled from 'styled-components';
import { Layout } from '@design-system';

export const StyledRecentPromptCard = styled(Layout.FlexCol)`
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
  position: relative;
`;
